import Button from 'components/Form/Button';
import { Icon, Icons } from 'components/Icon';
import React from 'react';
import BeneficiaryTable from './BeneficiaryTable';
import ActivitySummary from './ActivitySummary';
import { Link } from 'react-router-dom';

export default function InCompleteDashboard() {
  return (
    <div>
      <div className="mt-5 w-full rounded-md border border-gray-200 bg-white p-4 text-center sm:p-8">
        <p className="mb-5 text-lg font-normal text-[#353535] sm:text-lg">
          You are yet to complete you account setup
        </p>
        <div className="items-center justify-center space-y-4 rtl:space-x-reverse sm:flex sm:space-x-4 sm:space-y-0">
          <Link to="/dashboard/onboarding">
            <Button
              variant="outline"
              size="custom"
              className="place-self-end rounded-sm border-[#FF7A00] bg-[#FF6600] px-8 py-2.5 text-center text-xs font-medium text-white"
              label="Complete account setup"
              type="button"
              iconPosition="right"
              icon={<Icon name={Icons.ArrowRight} />}
            ></Button>
          </Link>
        </div>
      </div>
      <div className="mt-3">
        <div className="grid grid-cols-12 gap-5">
          <div className="col-span-12 w-full lg:col-span-8">
            <BeneficiaryTable hideTable />
          </div>
          <div className="col-span-12 w-full lg:col-span-4">
            <div className="w-full rounded-lg bg-white">
              <p className="p-5 text-sm font-semibold text-[#353535]">
                Asset Allotment
              </p>
              <div className="flex flex-col items-center justify-center">
                <div className="flex items-center">
                  <div className="z-10 flex h-[13rem] w-[13rem] shrink-0 items-center justify-center rounded-full bg-[#FF6600]">
                    <div className="flex h-40 w-40 items-center justify-center rounded-full bg-white">
                      <div className="flex h-20 w-20 items-center justify-center rounded-full bg-white text-center shadow-2xl">
                        <p className="text-2xl text-[#353535]">N/A</p>
                      </div>
                    </div>
                  </div>
                  <div className="flex h-0.5 w-full bg-gray-200 dark:bg-gray-700"></div>
                </div>
              </div>
              <div className="flex items-center justify-between px-10 py-4">
                <div className="mt-2 flex flex-col space-y-2">
                  <span className="me-3 flex items-center text-xs font-medium text-gray-900">
                    <span className="me-1.5 flex h-2.5 w-2.5 shrink-0 rounded-full bg-[#FF6600]"></span>
                    N/A
                  </span>
                  <span className="me-3 flex items-center text-xs font-medium text-gray-900">
                    <span className="me-1.5 flex h-2.5 w-2.5 shrink-0 rounded-full bg-[#FF6600]"></span>
                    N/A
                  </span>
                </div>
                <div className="mt-2 flex flex-col space-y-2">
                  <span className="me-3 flex items-center text-xs font-medium text-gray-900">
                    <span className="me-1.5 flex h-2.5 w-2.5 shrink-0 rounded-full bg-[#FF6600]"></span>
                    N/A
                  </span>
                  <span className="me-3 flex items-center text-xs font-medium text-gray-900">
                    <span className="me-1.5 flex h-2.5 w-2.5 shrink-0 rounded-full bg-[#FF6600]"></span>
                    N/A
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="mt-3">
        <div className="grid grid-cols-12 gap-5">
          <div className="col-span-12 w-full lg:col-span-8">
            <ActivitySummary />
          </div>
          <div className="col-span-12 w-full lg:col-span-4">
            <div className="w-full rounded-lg bg-white">
              <p className="px-5 pt-3 text-sm font-semibold text-[#353535]">
                How To...
              </p>
              <div className="flex flex-col">
                <iframe
                  className="h-56 p-4"
                  src="https://www.youtube.com/embed/JhdK5LahhDU"
                  allow="autoplay; encrypted-media"
                ></iframe>
              </div>
              <div className="px-5 pb-5">
                <p className="text-sm font-semibold text-[#FF6606]">
                  Will Writing Explained
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
